import { useQuery } from '@tanstack/react-query';
import type { AgentApiCsvMappingTemplatesShow } from '@/types/serializers';

export default function useFetchCsvMappingTemplate(templateId: string) {
  return useQuery({
    queryKey: ['csvMappingTemplate', templateId],
    queryFn: async () => {
      const response = await fetch(`/agent/api/csv_mapping_templates/${templateId}`);
      if (!response.ok) {
        throw new Error('CSVマッピングテンプレートの取得に失敗しました');
      }
      const data: AgentApiCsvMappingTemplatesShow = await response.json();
      return data;
    },
    enabled: !!templateId,
  });
}
